import {
  PSMS_RECOVERY_RATES_TREND_REQUEST,
  PSMS_RECOVERY_RATES_TREND_SUCCESS,
  PSMS_RECOVERY_RATES_TREND_FAILURE,
  PSMS_RECOVERY_RATES_TREND_LOADING,
  PSMS_SETTLEMENTS_DETAILS_REQUEST,
  PSMS_SETTLEMENTS_DETAILS_SUCCESS,
  PSMS_SETTLEMENTS_DETAILS_FAILURE,
  PSMS_SETTLEMENTS_DETAILS_LOADING,
  PSMS_AR_SUMMARY_REQUEST,
  PSMS_AR_SUMMARY_SUCCESS,
  PSMS_AR_SUMMARY_FAILURE,
  PSMS_AR_SUMMARY_LOADING,
} from '../../../actions/actionTypes';

/**
 * Interface for Recovery Rates Trend state
 */
export interface RecoveryRatesTrendState {
  loading: boolean;
  data: any | null;
  error: string | null;
}

/**
 * Interface for Settlements Details state
 */
export interface SettlementsDetailsState {
  loading: boolean;
  data: {
    total: {
      Details: any[];
      startDate: string | null;
      endDate: string | null;
    };
    open: {
      Details: any[];
      startDate: string | null;
      endDate: string | null;
    };
    closed: {
      Details: any[];
      startDate: string | null;
      endDate: string | null;
    };
  } | null;
  error: string | null;
}

/**
 * Combined interface for AccountsReceivable state
 */
export interface ARSummaryState {
  loading: boolean;
  data: {
    claimsOverturnData: any | null;
    paymentMetricsData: any | null;
  } | null;
  error: string | null;
}

export interface AccountsReceivableState {
  recoveryRatesTrend: RecoveryRatesTrendState;
  settlementsDetails: SettlementsDetailsState;
  arSummary: ARSummaryState;
}

/**
 * Initial state for AccountsReceivable reducer
 */
const initialState: AccountsReceivableState = {
  recoveryRatesTrend: {
    loading: true,
    data: null,
    error: null,
  },
  settlementsDetails: {
    loading: true,
    data: null,
    error: null,
  },
  arSummary: {
    loading: true,
    data: null,
    error: null,
  },
};

/**
 * AccountsReceivable reducer to manage Recovery Rates Trend and Settlements Details data
 * @param state - Current state
 * @param action - Action object
 * @returns Updated state
 */
export default function accountsReceivableReducer(
  state: AccountsReceivableState = initialState,
  action: any
): AccountsReceivableState {
  switch (action.type) {
    // Recovery Rates Trend cases
    case PSMS_RECOVERY_RATES_TREND_REQUEST:
      return {
        ...state,
        recoveryRatesTrend: {
          ...state.recoveryRatesTrend,
          loading: true,
          data: null,
          error: null,
        },
      };

    case PSMS_RECOVERY_RATES_TREND_LOADING:
      return {
        ...state,
        recoveryRatesTrend: {
          ...state.recoveryRatesTrend,
          loading: action.payload,
        },
      };

    case PSMS_RECOVERY_RATES_TREND_SUCCESS:
      return {
        ...state,
        recoveryRatesTrend: {
          ...state.recoveryRatesTrend,
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case PSMS_RECOVERY_RATES_TREND_FAILURE:
      return {
        ...state,
        recoveryRatesTrend: {
          ...state.recoveryRatesTrend,
          loading: false,
          data: null,
          error: action.payload,
        },
      };

    // Settlements Details cases
    case PSMS_SETTLEMENTS_DETAILS_REQUEST:
      return {
        ...state,
        settlementsDetails: {
          ...state.settlementsDetails,
          loading: true,
          data: null,
          error: null,
        },
      };

    case PSMS_SETTLEMENTS_DETAILS_LOADING:
      return {
        ...state,
        settlementsDetails: {
          ...state.settlementsDetails,
          loading: action.payload,
        },
      };

    case PSMS_SETTLEMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        settlementsDetails: {
          ...state.settlementsDetails,
          loading: false,
          data: action.payload,
          error: null,
        },
      };

    case PSMS_SETTLEMENTS_DETAILS_FAILURE:
      return {
        ...state,
        settlementsDetails: {
          ...state.settlementsDetails,
          loading: false,
          data: null,
          error: action.payload,
        },
      };

    case PSMS_AR_SUMMARY_REQUEST:
      return { ...state, arSummary: { loading: true, data: null, error: null } };

    case PSMS_AR_SUMMARY_LOADING:
      return { ...state, arSummary: { ...state.arSummary, loading: action.payload } };

    case PSMS_AR_SUMMARY_SUCCESS:
      return { ...state, arSummary: { loading: false, data: action.payload, error: null } };

    case PSMS_AR_SUMMARY_FAILURE:
      return { ...state, arSummary: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
}
